import api from '../../api/axios';

// Action types
export const EVENTS_LIST_REQUEST = 'EVENTS_LIST_REQUEST';
export const EVENTS_LIST_SUCCESS = 'EVENTS_LIST_SUCCESS';
export const EVENTS_LIST_FAILURE = 'EVENTS_LIST_FAILURE';

export const EVENTS_AGG_REQUEST = 'EVENTS_AGG_REQUEST';
export const EVENTS_AGG_SUCCESS = 'EVENTS_AGG_SUCCESS';
export const EVENTS_AGG_FAILURE = 'EVENTS_AGG_FAILURE';

// Thunk: fetch paginated events list
export const fetchAppEvents = ({ limit = 100, cursor = '' /*, startDate = '', endDate = ''*/ } = {}) => async (dispatch) => {
  try {
    dispatch({ type: EVENTS_LIST_REQUEST });
    const body = { limit, cursor /*, startDate, endDate*/ };
    const response = await api.post('shopify/appEvents', body);
    const data = response?.data || {};
    dispatch({ type: EVENTS_LIST_SUCCESS, payload: data });
    return data;
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to fetch app events';
    dispatch({ type: EVENTS_LIST_FAILURE, error: message });
    throw error;
  }
};

// Thunk: fetch aggregate events
export const fetchAppEventsAggregate = ({ /*startDate = '', endDate = ''*/ } = {}) => async (dispatch) => {
  try {
    dispatch({ type: EVENTS_AGG_REQUEST });
    const body = { aggregate: true /*, startDate, endDate*/ };
    const response = await api.post('shopify/appEvents', body);
    const data = response?.data || {};
    dispatch({ type: EVENTS_AGG_SUCCESS, payload: data });
    return data;
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to fetch events aggregate';
    dispatch({ type: EVENTS_AGG_FAILURE, error: message });
    throw error;
  }
};


